<template>

  <div v-wechat-title="titleTop" class="backRect">
    <div class="allBack" />
    <audio id="audioBgm" autoplay loop preload="auto">
      <source src="https://res.diveboss.net/activity/third/ilab202010/bgm.mp3" type="audio/mpeg">
    </audio>
    <audio ref="audio" src="https://res.diveboss.net/activity/third/ilab202010/click.mp3" />
    <div v-if="pageName==='login'" class="startLoginRect">
      <div class="startLogin">
        <img src="https://res.diveboss.net/activity/third/ilab202010/recoveryicon.png">
        <div class="loginBarBack">
          <div class="loginBar" :style="'width:'+loginProgress+'%'" />
        </div>
        <div class="loginText">Loading....{{ loginProgress }}%</div>
      </div>
    </div>
    <div v-if="pageName==='start'" class="startRect">
      <div class="backImg"><img src="https://res.diveboss.net/activity/third/ilab202010/whitesign.jpg"></div>
      <div class="backImg1"><img src="https://res.diveboss.net/activity/third/ilab202010/whitesign.jpg"></div>
      <div class="logoLine">
        <img src="https://res.diveboss.net/activity/third/ilab202010/LOGO.png">
      </div>
      <div class="TitleLine1">你够<span>绿</span>吗?</div>
      <div class="TitleLine2">听说掌握这些，就能拯救世界</div>
      <div v-if="!userInfo.isFollow" class="FollowRect">
        <div class="title">你还没有关注iLab公众号哦!</div>
        <div class="qrRect"><img src="https://res.diveboss.net/activity/third/ilab202010/qrcode.jpg"></div>
        <van-button v-if="!isIOS" class="button" size="small" @click="onFollowWx">扫一扫 关注公众号</van-button>
        <div v-if="isIOS" class="title">长按 关注公众号!<br>在公众号对话框输入“绿”</div>
      </div>

      <div v-if="userInfo.isFollow" class="NextButton NextButtonSelect">
        <van-button class="button" size="small" @click="pageName='about';$refs.audio.play();">进来看看</van-button>
        <div class="arrow"><img src="https://res.diveboss.net/activity/third/ilab202010/arrow.gif"></div>
      </div>
    </div>
    <div v-if="pageName==='about'" class="startRect">
      <div class="backImg"><img src="https://res.diveboss.net/activity/third/ilab202010/whitesign.jpg"></div>
      <div class="backImg1"><img src="https://res.diveboss.net/activity/third/ilab202010/whitesign.jpg"></div>
      <div class="logoLine">
        <img src="https://res.diveboss.net/activity/third/ilab202010/LOGO.png">
      </div>
      <div class="TitleLine1">你够<span>绿</span>吗?</div>
      <div class="TitleLine2">听说掌握这些，就能拯救世界</div>
      <div class="AboutLine">
        每天被问：“你是什么垃圾？”<br>
        是时候让自己更绿了<br>
        这里有本硬核《绿皮书》<br>
        每天一个变绿小技巧<br>
        做最发绿光的地球锦鲤
      </div>
      <div class="NextButton NextButtonSelect">
        <van-button class="button" size="small" @click="pageName='info';$refs.audio.play();">挑战一下</van-button>
        <div class="arrow"><img src="https://res.diveboss.net/activity/third/ilab202010/arrow.gif"></div>
      </div>
    </div>
    <div v-if="pageName==='info'" class="infoRect">
      <div class="greenBack1"><img src="https://res.diveboss.net/activity/third/ilab202010/greensign.jpg"></div>
      <div class="greenBack2"><img src="https://res.diveboss.net/activity/third/ilab202010/greensign.jpg"></div>
      <div class="whithBack"><img src="https://res.diveboss.net/activity/third/ilab202010/greenback.png"></div>
      <div class="frontInfo">
        <div class="TitleLine1">你够<span>绿</span>吗?</div>
        <div class="TitleLine2">听说掌握这些，就能拯救世界</div>
        <div class="inputButton">请输入你的昵称:</div>
        <div class="inputPoint">
          <span style="color:#9AC600">●</span>
          <span style="color:#AADB00">●</span>
          <span style="color:#5C7700">●</span>
        </div>
        <div class="nickNameRect">
          <van-field v-model="nickName" class="inputRect" maxlength="10" />
        </div>
        <div class="NextButton NextButtonSelect">
          <van-button class="button" size="small" @click="pageName='select';$refs.audio.play();">进来看看</van-button>
          <div class="arrow"><img src="https://res.diveboss.net/activity/third/ilab202010/arrow.gif"></div>
        </div>
      </div>
    </div>
    <div v-if="pageName==='select'" class="selectRect">
      <div class="BarLine">
        <div class="selectNum" @click="showQuestionList=!showQuestionList">
          <div class="num">{{ totalSelectNum }}</div>
          <div class="title">已做到</div>
        </div>
        <div class="titleLine">
          <div class="title">这些绿色<i class="iconfont iconhuanbao" />小习惯</div>
          <div class="title1">你能做到几条?</div>
        </div>
      </div>
      <div id="scrollRect" class="scrollRect">
        <div v-for="question in qustionList" :key="question.id" :class="question.isSelect?'QuestionRect select':'QuestionRect'" @click="onSelectQuestion(question)">
          <div v-if="question.isSelect" class="icon">
            <img :src="'https://res.diveboss.net/activity/third/ilab202010/icon'+question.group+'.jpg'">
          </div>
          <div class="bodyRect">
            <div v-if="question.id==='1' && totalSelectNum === 0" class="noticeRect"><img src="https://res.diveboss.net/activity/third/ilab202010/arrow.gif">
              &nbsp;<span>点亮</span> &nbsp;选择
            </div>
            <div class="title">{{ question.id }}.{{ question.title }}</div>
            <div v-if="question.isSelect" class="about">{{ question.about }}</div>
          </div>
        </div>
        <div class="NextButton NextButtonSelect" style="width:60vw;margin-left: 20vw;">
          <van-button class="button" @click="onFinish">我只能这么绿了</van-button>
          <div class="arrow"><img src="https://res.diveboss.net/activity/third/ilab202010/arrow.gif"></div>
        </div>
        <div class="emptyRect" />
      </div>
      <div id="MoveRect" class="MoveRect">试一试&nbsp;&nbsp;上下滑动</div>
      <div v-if="showQuestionList" class="NowSelectRect">
        <van-row v-for="item in qustionList.filter(el=>el.isSelect)" :key="item.id" class="line">
          <van-col span="20">{{ item.id }}.{{ item.title }}</van-col>
          <van-col span="4" class="rigth"><i class="iconfont iconclosex" @click="onSelectQuestion(item)" /></van-col>
        </van-row>
        <div class="downClose" @click="showQuestionList=false">收起来<i class="iconfont iconupjt" /></div>
        <div class="jt" />
      </div>
    </div>
    <div v-if="pageName==='finish'" class="startLoginRect">
      <div class="fullback"><img src="https://res.diveboss.net/activity/third/ilab202010/outBack.jpg"></div>
      <div v-if="imgLoading" class="startLogin">
        <img src="https://res.diveboss.net/activity/third/ilab202010/recoveryicon.png">
        <div class="loginBarBack">
          <div class="loginBar" :style="'width:'+loginProgress+'%'" />
        </div>
        <div class="loginTextCenter">你达成了{{ totalSelectNum }}个绿色成就噢!</div>
      </div>
      <div v-show="!imgLoading" class="finishImage">
        <van-image width="100%" :src="imgUrl" @load="onImgLoadFinish" @click="showShare=true" />
      </div>
    </div>
    <wxShare v-model="showShare" share-title="点击这里分享" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Image } from 'vant'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
// import fullError from '@/components/fullError'
import wxShare from '@/components/wxShare'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image,
    wxShare
  },
  data() {
    return {
      isIOS: false,
      titleTop: '你够绿吗？',
      imgUrl: undefined,
      userInfo: {
        thirdUserId: undefined,
        isFollow: false
      },
      pageName: 'login',
      loginProgress: 1,
      nickName: 'iLab',
      totalSelectNum: 0,
      imgLoading: true,
      showQuestionList: false,
      qustionList: [
        { id: '1', group: '1', isSelect: false, title: '动物不该是“打工人”', about: '为了达到娱乐观众的目的，让动物做出违背其自然天性的动作和行为，且训练过程中，随处可见虐待动物现象。没有购买就没有伤害，别让动物打工啦' },
        { id: '2', group: '2', isSelect: false, title: '每天问问：你是什么垃圾', about: '家中常备三个分类垃圾桶，对垃圾进行分类不仅减少垃圾占用面积以及环境污染，还能在分类过程中得到很多可利用资源' },
        { id: '3', group: '3', isSelect: false, title: '薅羊毛，选太阳能', about: '太阳能是最环保的能量来源，免费无污染，生活中已经很吃亏了，大自然的便宜就多占一占吧' },
        { id: '4', group: '4', isSelect: false, title: '多用电的，少用油的', about: '国家都在补助新能源汽车，为啥？零排放零尾气这么好的事上哪找去' },
        { id: '5', group: '3', isSelect: false, title: '省电，绝不是因为抠', about: '节约用电可是不是为了省电费，每节约1度电，就会减少消耗400克煤，少排放1千克二氧化碳' },
        { id: '6', group: '5', isSelect: false, title: '购物，学会往自己兜里揣', about: '减塑生活，从最常见的做起，不使用超市提供的塑料袋，自备布袋、菜篮或循环利用的塑料袋，就是最最环保的小事' },
        { id: '7', group: '1', isSelect: false, title: '不吃野生动物', about: '以前不吃野生动物是保护动物，现在不吃野生动物是保护自己，疫情之下，抵制非法野生动物买卖，刻不容缓！' },
        { id: '8', group: '8', isSelect: false, title: '下海潜水，顺点宝贝', about: '很多潜水员在海里总能遇到人类活动产生的塑料垃圾，还经常有动物因塑料垃圾致死，所以，下海潜水的时候，能力范围里可以选择带走一些垃圾哦。' },
        { id: '9', group: '6', isSelect: false, title: '双面用纸，多用再生纸', about: '再生纸是用回收的废纸产生的，1吨废纸=800千克再生纸=17棵大树，森林可都掌握在你手里了' },
        { id: '10', group: '1', isSelect: false, title: '不穿貂', about: '为了一件皮草虐杀动物，这么血腥的事，相信你干不出来吧' },
        { id: '11', group: '4', isSelect: false, title: '能用公的，就不用私的', about: '减少私人汽车碳排量，同样一英里路程，公共交通则仅有汽车消耗燃料的一半，尽量选择公交地铁出行吧' },
        { id: '12', group: '2', isSelect: false, title: '旧衣物，捐一捐', about: '不想穿的旧衣服可以选择定期捐赠，由相关部门回收再生产，把废旧物品变成可利用的资源，能减少垃圾焚烧和环境部门的工作' },
        { id: '13', group: '4', isSelect: false, title: '少用进口的，多用本土的', about: '进口食品特别是水果，会增大运输排放成本，多选择本土产品，支持国货' },
        { id: '14', group: '5', isSelect: false, title: '少吃外卖', about: '外卖中大量使用无法降解的塑料包装盒，同时产生很多一次性垃圾，有空就自己做做饭吧' },
        { id: '15', group: '5', isSelect: false, title: '做个现代人，全电子化', about: '办公多用电子邮件、微信、钉钉等即时通讯工具，减少打印机和传真机这种古老又废纸的方法查阅文件' },
        { id: '16', group: '6', isSelect: false, title: '竹质家具？也不错', about: '竹子的生长周期只有木材的十分之一，吸潮和吸热都高于木头，成本也更低，森林这么重要，咱们还是少用木质的吧' },
        { id: '17', group: '2', isSelect: false, title: '低头弯腰，是种荣耀', about: '平时低头弯腰顺手捡个垃圾，或者参加一些街道、海滩清洁，为环境做出一份力所能及的努力' },
        { id: '18', group: '7', isSelect: false, title: '关，就关得彻底', about: '电视电脑，关闭时最好彻底切断电源，减少待机，只暂时将屏幕关闭，实际并没有完全切断电源的待机状态，耗电约1.2瓦/小时，耗电量一般为其开机功率的10%左右。' },
        { id: '19', group: '5', isSelect: false, title: '不用塑料吸管', about: '现在大多数商家已经开始用无需吸管的饮料杯盖，或者尽量选择纸吸管，还有一种减塑不锈钢吸管，夏天用很激爽，还是种防身利器' },
        { id: '20', group: '6', isSelect: false, title: '山区林区不焚烧', about: '焚烧不仅会大量排放排放二氧化碳，一不小心放火烧山，整个植被都会大面积破坏' },
        { id: '21', group: '8', isSelect: false, title: '参与种树、种珊瑚活动', about: '珊瑚礁是25%海洋生物的栖息地，约有70-90%的海浪冲击力在遭遇珊瑚礁时会被吸收或减弱，iLab曾经发起过涠洲岛种珊瑚的海洋公益活动，保护珊瑚也是保护海洋生态。' },
        { id: '22', group: '3', isSelect: false, title: '自然光才是你最需要的', about: '自然光是没有能耗污染的免费光源，浅色的室内装修和大面积的窗户能很好地利用自然光，尽量白天把工作做完也是不错的方式，而且自然光下自拍一般更好看' },
        { id: '23', group: '8', isSelect: false, title: '选择对珊瑚无害的防晒霜', about: '一滴不恰当化学防晒剂，可造成7个游泳池大小的珊瑚白化，ps: 保护珊瑚，建议使用iLab小银瓶，真正对珊瑚无害的防晒' },
        { id: '24', group: '2', isSelect: false, title: '把这本《绿皮书》分享出去', about: '如果绿色太难，至少可以做到这条，让更多人加入绿色行动' }
      ],
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: undefined,
      shareIcon: ''
    }
  },
  created() {
    var u = navigator.userAgent
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    this.init()
    document.addEventListener('scroll', this.handleScroll, true)

    document.addEventListener('DOMContentLoaded', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
        document.addEventListener('WeixinJSBridgeReady', function() {
          audio.play()
        }, false)
      }
      audioAutoPlay()
    })
    // --创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
    document.addEventListener('touchstart', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
    document.addEventListener('WeixinJSBridgeReady', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onShareFinish() {
      this.shareUrl = undefined
    },
    beforeDestroy() {
      document.removeEventListener('scroll', this.listenerFunction)
    },
    handleScroll() {
      var dom = document.getElementById('scrollRect')
      if (dom) {
        console.log('scrollTop', dom.scrollTop)
        console.log('clientHeight', dom.clientHeight)
        console.log('scrollHeight', dom.scrollHeight)
        var fullHeight = dom.scrollHeight - dom.clientHeight
        var nowh = dom.scrollTop / fullHeight * 50 + 30
        var testDom = document.getElementById('MoveRect')
        testDom.style.top = nowh + 'vw'
        testDom.style.opacity = 1 - (dom.scrollTop / (fullHeight * 0.2))
      }
    },
    onFollowWx() {
      this.$refs.audio.play()
      var wxBiz = 'MzI4MzkwMTc1NA=='
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=' + wxBiz + '&scene=110#wechat_redirect'
    },
    onUnFollow() {
      MyNotify('info', '你还没有关注iLab公众号哦!')
      this.$refs.audio.play()
    },
    initShare(url) {
      this.shareTitle = '你够绿吗？'
      this.shareAbout = '听说掌握这些，就能拯救世界 ...'
      this.shareTimeline = '你够绿吗？'
      this.shareIcon = GetSelfUrl() + 'img/third/ilab202010/shareIcon.jpg'
      this.shareUrl = undefined
      this.shareUrl = 'https://m.diveboss.net/ilab/202010'
    },
    init() {
      var thirdUserId = getUrlKey('thirdUserId')
      var code = getUrlKey('code')
      if (!thirdUserId && !code) {
        // 登录
        this.getWxLoginUrl((url) => {
          console.log('跳转页面去登录', url)
          window.location.href = url
        })
        return
      }

      this.$router.push('/ilab/202010')
      var my = this
      var loginPro = setInterval(() => {
        my.loginProgress += 1
        if (my.loginProgress > 99) {
          my.loginProgress = 99
          clearInterval(loginPro)
        }
      }, 10)
      if (thirdUserId) {
        this.loginAndRegThirdUserInfo(null, thirdUserId, () => {
          this.loginThirdFinish(my)
          this.initShare()
        })
      } else {
        // 读取注册用户信息
        this.loginAndRegThirdUserInfo(code, null, () => {
          this.loginThirdFinish(my)
          this.initShare()
        })
      }
    },
    loginThirdFinish(my) {
      if (my.userInfo.isFollow) {
        my.$router.push('/ilab/202010?thirdUserId=' + my.userInfo.thirdUserId)
      }
      if (my.userInfo.nickName) {
        my.nickName = my.userInfo.nickName
      }
      if (my.loginProgress > 80) {
        my.pageName = 'start'
      } else {
        setTimeout(() => {
          my.pageName = 'start'
        }, 500)
      }
    },
    loginAndRegThirdUserInfo(code, thirdUserId, callback) {
      request({
        url: '/ThirdActivitie/GetAndRegThirdActiviteUser',
        method: 'post',
        data: {
          code: code,
          thirdUserId: thirdUserId,
          type: 'iLab',
          keyCode: 'iLab202010'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.userInfo = Response.data
        if (callback) {
          callback()
        }
      })
    },
    getWxLoginUrl(callback) {
      request({
        url: '/ThirdActivitie/wechatLogin',
        method: 'post',
        data: {
          url: 'https://m.diveboss.net/ilab/202010',
          type: 'iLab'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        var url = Response.data
        if (callback) {
          callback(url)
        }
      })
    },
    onSelectQuestion(question) {
      question.isSelect = !question.isSelect
      this.totalSelectNum = this.qustionList.filter(el => el.isSelect).length
    },
    onFinish() {
      this.$refs.audio.play()
      this.pageName = 'finish'
      this.loginProgress = 0
      this.imgLoading = true
      // 处理连接信息
      var url = 'https://api.diveboss.net/userAPI/ThirdActivitie/GetiLab202010Image?nickName=' + this.nickName +
        '&thirdUserId=' + this.userInfo.thirdUserId
      var i = 0
      var groupIdList = []
      this.qustionList.forEach(el => {
        if (el.isSelect) {
          url += ('&selectList[' + i + ']=' + el.id)
          i++
          var isHave = groupIdList.filter(item => item === el.group).length > 0
          if (!isHave) {
            groupIdList.push(el.group)
          }
        }
      })
      i = 0
      groupIdList.forEach(el => {
        url += ('&groupList[' + i + ']=' + el)
        i++
      })
      this.imgUrl = url

      // 设置进度
      var my = this
      var loginPro = setInterval(() => {
        my.loginProgress += 1
        if (my.loginProgress > 99) {
          my.loginProgress = 99
          clearInterval(loginPro)
        }
      }, 10)
    },
    onImgLoadFinish() {
      if (this.loginProgress > 80) {
        this.imgLoading = false
      } else {
        setTimeout(() => {
          this.imgLoading = false
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>
.startLoginRect{
  min-height: 100vh;
  background-color: #C2FF0B;
  position: relative;
}
.startLogin{
  position: absolute;
  top: 50%;
  height: 30vh;
  width: 100%;

  margin-top:-15vh;
  text-align: center;
}
.startLogin img{
  height: 30%;
}

.startLogin .loginBarBack{
  height: 0.5em;
  border:1px solid #000;
  border-radius: 0.5em;
  width: 56%;
  margin-left: 22%;
  margin-top: 1.5em;
  position: relative;
  overflow: hidden;
}
.startLogin .loginBarBack .loginBar{
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width:10%;
  background-color: #fff;
  background: -webkit-linear-gradient(to right,white,black); /* Safari 5.1-6.0 */
  background: -o-linear-gradient(to right,white,black); /* Opera 11.1-12.0 */
  background: -moz-linear-gradient(to right,white,black); /* Firefox 3.6-15 */
  background: linear-gradient(to right,white,black); /* 标准语法 */
}

.startLogin .loginText{
    font-size: 0.9em;
    margin-top: 1.5em;
    text-align: center;
}
.startLogin .loginTextCenter{
    font-size: 0.9em;
    margin-top: 1.5em;
    text-align: center;
}
.allBack{
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -10;
}
.startRect{
  height: 100vh;
  width: 100%;
  /* background-image: url(https://res.diveboss.net/activity/third/ilab202010/whiteback.jpg);
  background-position: center center;
  background-size: cover;
  background-size:100% 100%;
  -moz-background-size:100% 100%;
  */
}

.startRect .backImg{
  position: fixed;
  height: 100vh;
  z-index: -1;
  animation: scrollBad 40s linear infinite;
  -webkit-animation: scrollBad 40s linear infinite;
}
.startRect .backImg1{
  position: fixed;
  height: 100vh;
  z-index: -2;
  animation: scrollBad 40s linear -20s infinite;
  -webkit-animation: scrollBad 40s linear  -20s infinite;
}

.startRect .backImg img{
  height: 100%;
}
.startRect .backImg1 img{
  height: 100%;
}
@keyframes scrollBad {
    0% {
      left:147.55vh;
    }
    100% {
      left: -147.55vh;
    }
}

.startRect .logoLine img{
  padding: 10vw;
  width: 25%;
  margin-top: 3vw;
}
.startRect .TitleLine1{
  margin-top: 5vw;
  font-size: 13vw;
   font-weight: 600;
  text-align:  center;
}
.startRect .TitleLine1 span{
  color: #99C741;
}
.startRect .TitleLine2{
  width:60vw;
  font-size: 4.2vw;
  height: 8vw;
  line-height: 8vw;
  text-align: center;
  background-color: #000;
  color:#D0FB3A;
  margin-left:20vw;
  margin-top: 5vw;
}
.startRect .AboutLine{
  font-size: 4.2vw;
  text-align: center;
  margin-top: 10vw;
  margin-bottom: 5vw;
  line-height: 6.5vw;
}
.startRect .FollowRect
{
  width: 60vw;
  margin-left: 20vw;
  margin-top: 10vw;
  border: 1px solid #000;
  padding: 5vw 0;
  background-color: #fff;
}
.startRect .FollowRect .title
{
  font-size: 4vw;
  text-align: center;
}
.startRect .FollowRect .qrRect{
  width: 24vw;
  padding-left: 18vw;
  padding-top: 3vw;
  text-align: center;
}
.startRect .FollowRect .qrRect img{
  width: 100%;

}
.startRect .FollowRect .button{
  text-align: center;
  background-color:#C7FF00;
  border: 1px solid #000;
  width: 40vw;
  margin-left: 10vw;
  margin-top: 5vw;
  font-weight: 700;
  font-size: 3.8vw;
}
 .NextButton{
  width: 40vw;
  margin-left: 30vw;
  margin-top: 10vw;
  position: relative;

}
 .NextButton .arrow{
  position: absolute;
  right: 1vw;
  bottom: -6vw;
  width: 7vw;
}
 .NextButton .arrow img{
  width: 100%;
}
 .NextButton .button{
  width: 100%;
  background-color: #BFBFBF;
  color: #000;
  font-size: 4.5vw;
  border: 1px solid #000;
  font-weight: 700;
}
 .NextButtonSelect .button{
    background-color: #C7FF00 !important;
 }
.infoRect{
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.infoRect .whithBack{
  position: absolute;
  left: 0;
  bottom: 0;
  right:0;
  top: 0;
}
.infoRect .whithBack img{
  height: 100%;
  width: 100%;
}

.infoRect .greenBack1{
  position: absolute;
  left: 0;
  top:0;
  bottom: -10px;
  z-index: -2;
  animation: scrollBad1 40s linear infinite;
  -webkit-animation: scrollBad1 40s linear infinite;
}
.infoRect .greenBack1 img{
  height: 100vh;
}
.infoRect .greenBack2{
  position: absolute;
  left: 0;
  top:0;
  bottom: -10px;
  z-index: -2;
  animation: scrollBad1 40s linear -20s infinite;
  -webkit-animation: scrollBad1 40s linear  -20s infinite;
}
.infoRect .greenBack2 img{
  height: 100vh;

}
@keyframes scrollBad1 {
    0% {
      left:147.55vh;
    }
    100% {
      left: -147.55vh;
    }
}
.infoRect .frontInfo{
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
}
.infoRect .TitleLine1{
  width: 35vw;
  font-size: 7vw;
   font-weight: 600;
  padding-top: 15vw;
  padding-left: 10vw;
  text-align:  center;
}
.infoRect .TitleLine1 span{
  color: #99C741;
}
.infoRect .TitleLine2{
  width:31vw;
  font-size: 2.1vw;
  height: 4vw;
  line-height: 4vw;
  text-align: center;
  background-color: #000;
  color:#D0FB3A;
  margin-left:12vw;
  margin-top: 2vw;
}
.infoRect .inputButton{
  font-weight: 10vw;
  text-align: center;
  margin-top: 30vw;
  line-height: 10vw;
}
.infoRect .inputPoint{
  font-weight: 10vw;
  text-align: center;
}
.infoRect .inputPoint span{
  padding: 0 0.5vw;
}
.infoRect .nickNameRect{
  border:1px solid #000;
  background-color: transparent;
  font-size: 18vw;
  font-weight: 700;
  width: 50vw;
  margin-left: 25vw;
  margin-top: 3vw;
}

.selectRect{
  background-color: #fff;
  width: 100%;
}
.selectRect .BarLine{
  width: 100%;
  height: 20vw;
  position: relative;
}
.selectRect .BarLine .selectNum{
  background-color: #1D2404;
  position: absolute;
  width: 16vw;
  height: 20vw;
  text-align: center;
  color: #fff;
}
.selectRect .BarLine .selectNum .num{
  font-size: 7vw;
  line-height: 12vw;
}
.selectRect .BarLine .selectNum .title{
  font-size: 4vw;
  line-height: 8vw;
}
.selectRect .BarLine .titleLine{
  margin-left: 16vw;
  height: 20vw;
  background-image: url(https://res.diveboss.net/activity/third/ilab202010/back.jpg);
  background-position: center center;
  background-size: cover;
  background-size:100% 100%;
  -moz-background-size:100% 100%;
}
.selectRect .BarLine .titleLine .title{
  font-size: 6vw;
  margin-left: 5vw;
  font-weight: 700;
  padding-top: 2.2vw;
}
.selectRect .BarLine .titleLine .title i{
  color: #AADB00;
  font-size: 6vw;
  padding: 0 2px;
}
.selectRect .BarLine .titleLine .title1{
  font-size: 4vw;
  margin-left: 5vw;
  color: #383737;
}
.selectRect .scrollRect{
  overflow-y: scroll;
  height: calc(100vh - 20vw);
}

.selectRect .scrollRect .QuestionRect{
  height: 21vw;
  position: relative;
}
.selectRect .scrollRect .QuestionRect .icon{
  position: absolute;
  height: 14vw;
  width: 14vw;
  left: 5vw;
  top:5vw;
}
.selectRect .scrollRect .QuestionRect .icon img{
  width: 100%;
}
.selectRect .scrollRect .QuestionRect .bodyRect{
  margin-left: 24vw;
  padding-top: 5vw;
  margin-right: 5vw;
  position: relative;
}
.selectRect .scrollRect .QuestionRect .bodyRect .noticeRect
{
  position:absolute;
  left: 40vw;
  font-size: 3.4vw;
  top: 7vw;
}
.selectRect .scrollRect .QuestionRect .bodyRect .noticeRect img{
  height: 3.4vw;
}
.selectRect .scrollRect .QuestionRect .bodyRect .noticeRect span{
  background-color: #000;
  color:#C7FF00;
  font-weight: 700;
  padding: 0.1vw 2vw;
}
.selectRect .scrollRect .QuestionRect .bodyRect .title{
  font-size: 3.4vw;
  font-weight: 700;
  margin-right: 10vw;
  padding: 0.5vw 0 0.5vw 2vw;
  border:1px solid #fff;
}
.selectRect .scrollRect .select .bodyRect .title{
  background-color: #C7FF00;
  border:1px solid #000;
}
.selectRect .scrollRect .QuestionRect .bodyRect .about{
  font-size: 2.6vw;
  line-height: 2.9vw;
  color: #636363;
  padding-right: 10vw;
  margin-top: 1vw;
}

.selectRect .NowSelectRect{
  position: absolute;
  left: 16vw;
  top: 0;
  width: 65vw;
  height: 90vh;
  background-color: #fff;
  border: 1px solid #000;
  z-index: 10;
  padding: 5vw;
  font-size: 4vw;
  line-height: 6.5vw;
}
.selectRect .NowSelectRect .line
{
  border-bottom: 1px solid #f5f5f5;
}
.selectRect .NowSelectRect .jt{
  position: absolute;
  left: 0;
  top: 6vw;
  border-width:3vw;
  border-style:solid;
  border-color: transparent transparent transparent  #000;
}
.selectRect .NowSelectRect .downClose{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  color: #fff;
  font-size: 4vw;
  line-height: 10vw;
  text-align: center;
}
.emptyRect{
  height: 10vw;
}
::-webkit-scrollbar
{
	width: 1px;
	height: 1px;
	background-color: #fff;
}
::-webkit-scrollbar-thumb
{
	background-color: #ccc;
}
.MoveRect{
  width: 5vw;
  height: 30vw;
  position: absolute;
  right: 6vw;
  font-size: 3vw;
  writing-mode: vertical-lr;
  text-align: center;
  top: 30vw;
  color: #999;
  border-right: 1px solid #000;
}
.MoveRect::after{
  display:block;
  content:'';
  border-width:2vw 2vw 2vw 2vw;
  border-style:solid;
  border-color:#000 transparent transparent transparent;
  position:absolute;
  right: -2vw;
  top:100%;
}
.MoveRect::before{
  display:block;
  content:'';
  border-width:2vw 2vw 2vw 2vw;
  border-style:solid;
  border-color: transparent  transparent #000 transparent;
  position:absolute;
  right: -2vw;
  top:-4vw;
}

.startLoginRect .fullback
{
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.startLoginRect .fullback img{
  width: 100%;
}
.startLoginRect .finishImage{
  z-index: 10;
}
</style>
